var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcStepArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "145px",
    height: "145px",
    viewBox: "0 0 145 145",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_step_arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 72.5,
    cy: 72.5,
    r: 72.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Teacher_Portal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Teacher_Portal-1.21---Guided-reading-flow-structure",
    transform: "translate(-199.000000, -392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(179.000000, 228.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(20.000000, 149.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_step_arrow",
    transform: "translate(0.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("circle", {
    stroke: "#62C3EE",
    strokeWidth: 2.4,
    cx: 72.5,
    cy: 72.5,
    r: 71.3
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#62C3EE",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)",
    points: "39.5780423 87.1768938 55.6259717 74.0420422 83.0406345 77.1406637 100.30883 61.7485422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3008657,59.5670359 L102.352873,73.774225 C102.754506,74.1533155 103.387407,74.1350413 103.766498,73.7334086 C103.953887,73.5348767 104.051962,73.268364 104.037961,72.9957223 L103.356764,59.7299273 C103.330752,59.2233598 102.929598,58.816505 102.423447,58.7833484 L88.0526369,57.8419542 C87.5015334,57.8058529 87.0255097,58.2233447 86.9894084,58.7744482 C86.9699259,59.0718572 87.0841202,59.3624557 87.3008657,59.5670359 Z",
    id: "Path-4",
    fill: "#62C3EE",
    mask: "url(#mask-2)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStepArrow);
export default __webpack_public_path__ + "static/media/ic_step_arrow.97351ca6ff252b7ba36d6f76fd6ad77e.svg";
export { ForwardRef as ReactComponent };